import React from 'react';

const ContactSection = () => (
  <section id="contacto" className="w-full py-12 md:py-24 lg:py-32 bg-white dark:bg-gray-950">
    <div className="container px-4 md:px-6">
      <div className="mx-auto max-w-3xl space-y-6 text-center">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900 dark:text-gray-100">
          Contáctanos
        </h2>
        <p className="text-gray-600 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
          Completa el formulario y nos pondremos en contacto contigo a la brevedad.
        </p>
        <form className="space-y-6 p-6 bg-gray-100 dark:bg-gray-900 rounded-lg shadow-lg">
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2 text-left">
              <label htmlFor="name" className="text-sm font-medium text-gray-700 dark:text-gray-300">Nombre</label>
              <input
                id="name"
                className="flex h-10 w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-700 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:ring-offset-gray-950 dark:placeholder:text-gray-500 dark:focus-visible:ring-teal-300"
                placeholder="Tu nombre completo"
                type="text"
              />
            </div>
            <div className="space-y-2 text-left">
              <label htmlFor="email" className="text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
              <input
                id="email"
                className="flex h-10 w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-700 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:ring-offset-gray-950 dark:placeholder:text-gray-500 dark:focus-visible:ring-teal-300"
                placeholder="tu.email@ejemplo.com"
                type="email"
              />
            </div>
          </div>
          <div className="space-y-2 text-left">
            <label htmlFor="service" className="text-sm font-medium text-gray-700 dark:text-gray-300">Servicio de Interés</label>
            <select
              id="service"
              className="flex h-10 w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-sm ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-700 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:ring-offset-gray-950 dark:focus-visible:ring-teal-300"
            >
              <option value="">Selecciona un servicio</option>
              <option value="asesoria_aduanal">Asesoría Aduanal</option>
              <option value="anexo_24_30">Anexo 24 y 30</option>
              <option value="expediente_digital">Expediente Digital VUCEM</option>
              <option value="agencia_aduanal">Agencia Aduanal</option>
              <option value="logistica_transporte">Logística y Transporte</option>
              <option value="integracion_sistemas">Integración de Sistemas</option>
              <option value="otro">Otro</option>
            </select>
          </div>
          <div className="space-y-2 text-left">
            <label htmlFor="subject" className="text-sm font-medium text-gray-700 dark:text-gray-300">Asunto</label>
            <input
              id="subject"
              className="flex h-10 w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-700 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:ring-offset-gray-950 dark:placeholder:text-gray-500 dark:focus-visible:ring-teal-300"
              placeholder="Motivo de tu consulta"
              type="text"
            />
          </div>
          <div className="space-y-2 text-left">
            <label htmlFor="message" className="text-sm font-medium text-gray-700 dark:text-gray-300">Mensaje</label>
            <textarea
              id="message"
              className="flex min-h-[120px] w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-sm ring-offset-white placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-700 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:ring-offset-gray-950 dark:placeholder:text-gray-500 dark:focus-visible:ring-teal-300 resize-y"
              placeholder="Escribe tu mensaje aquí..."
            ></textarea>
          </div>
          <button
            type="submit"
            className="inline-flex h-10 items-center justify-center rounded-md bg-indigo-700 px-8 text-sm font-medium text-white shadow transition-colors hover:bg-indigo-800 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-indigo-700 disabled:pointer-events-none disabled:opacity-50 dark:bg-teal-500 dark:text-gray-900 dark:hover:bg-teal-600 dark:focus-visible:ring-teal-300"
          >
            Enviar Mensaje
          </button>
        </form>
        <div className="flex flex-wrap justify-center gap-4 mt-4">
          <a 
            href="https://wa.me/5215512345678" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-flex h-10 items-center justify-center rounded-md bg-green-500 px-8 text-sm font-medium text-white shadow transition-colors hover:bg-green-600 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-green-500 disabled:pointer-events-none disabled:opacity-50"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
            </svg>
            Enviar WhatsApp
          </a>
          <a 
            href="tel:+525512345678" 
            className="inline-flex h-10 items-center justify-center rounded-md bg-green-600 px-8 text-sm font-medium text-white shadow transition-colors hover:bg-green-700 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-green-600 disabled:pointer-events-none disabled:opacity-50"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2H7c.45 0 .9.06 1.3.18a2 2 0 0 1 1.41.46L10.9 9.1a2 2 0 0 1-.45 2.11L8.09 13.91a16 16 0 0 0 6 6l1.72-1.72a2 2 0 0 1 2.11-.45l3.43 1.43a2 2 0 0 1 .46 1.4z"></path>
            </svg>
            Llamar Ahora
          </a>
        </div>
        <div className="w-full h-64 bg-gray-200 rounded-lg shadow-md flex items-center justify-center text-gray-600 dark:bg-gray-800 dark:text-gray-400 mt-8">
          Aquí iría el mapa de ubicación
        </div>
      </div>
    </div>
  </section>
);

export default ContactSection;